import CustomSpinner from "components/layout/Loader/Spinner";
import Pagination from "components/UI/pagination/Pagination";
import React, { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { LightgalleryProvider, LightgalleryItem } from "react-lightgallery";
import Singh from "../../../../assets/icons/singh.svg";
import Timer from "assets/images/comment-timer.svg";
import * as actions from "../../_redux/landingPageActions";
import { useLandingPageUIContext } from "../LandingPageUIContext";
import NoRecordFound from "utils/noRecordFound";
import "./style.scss";


export default function Trophies({ standId }) {
  const dashboardPageUIContext = useLandingPageUIContext();
  const dispatch = useDispatch();

  const { standTrophies, totalRecords, listLoading } = useSelector(
    (state) => ({
      listLoading: state.stand.listLoading,
      standTrophies: state.landingPage.standTrophies,
      totalRecords: state?.landingPage?.totalTrophiesRecords,
    }),
    shallowEqual
  );

  const dashboardPageUIProps = useMemo(() => {
    return {
      queryParams: dashboardPageUIContext.trophiesQueryParams,
      setQueryParams: dashboardPageUIContext.setTrophiesQueryParamsBase,
    };
  }, [dashboardPageUIContext]);

  useEffect(() => {
    dispatch(
      actions.fetchStandTrophies(standId, dashboardPageUIProps.queryParams)
    );
  }, [dashboardPageUIProps.queryParams, dispatch]);


  return (
    <div className={`trophies ${standTrophies?.length > 0 ? 'mt-4 pt-4' : ''}`}>
      {standTrophies && standTrophies?.length > 0 ? (
        standTrophies?.map((trophy, index) => (
          <div className="trophies-list mb-3 fade-in" key={index}>
            <LightgalleryProvider >
              <LightgalleryItem group="any" src={trophy?.image || Singh}>
                <div className="trophies-img cursor-pointer">
                  <img src={trophy?.image || Singh} alt="" />
                  <svg xmlns="http://www.w3.org/2000/svg" width="92.024" height="54.685" viewBox="0 0 92.024 54.685" className="singh">
                    <g id="LOGO" transform="translate(19.477 11.574)">
                      <path
                        id="Path_337"
                        data-name="Path 337"
                        d="M2246.5-344.783,2245.4-347l-1.493-1.985-1.542-1.732-1.8-1.467-1.389-.8v-.038l-.558-2.213-.416-1.808-.177-1.833-.178-3.1-.3-2.364-.112-.2-.229-.05-.191.1-.075.228-.039,1.517-.19,1.5-.316,1.884-.114,1.9.09,1.555.291,1.517v.013h-.053l-.162.126-.064.19.064.19.467.733.012.051.127,1.416-.051,1.429.064,3.578.088,1.353.2,1.353.227,1.378.075,1.391-.187.683-.405.569-.581.4-2.543.986-2.668.607h-.847l-.81-.278-.669-.531-.457-.721-.719-2.706-.431-2.756-.165-3.2.191-3.212-.1-1.96-.4-1.922-.686-1.833-.606-1.808-.366-1.871-.227-.847-.406-1.366-.039-.164-.138-.1-.163-.013-.14.1-.064.152.405,3,.594,2.971.317,1.783.076,1.808-.179,1.808-.24.253-.353.076-.317-.126-.821-.417-.533-.278-.138-.076-.153.013-.087.063-.039.114.039.1.4.518.454.506.634,1.011.416,1.694.2,1.732-.039,1.732-.052,1.783.153,1.783.43,2.238.1,1.239.015-.013v.114l-.015-.1-.225.48-.469.291-2.9.746-2.742,1.189-1.341.645-1.264.759-.481.114-.442-.2-.242-.442-.011.379-.176-1.719-1.252-4.324-1.518-4.236-.6-1.618-.708-2.971-.505-3.009-.19-1.113-.339-2.1-.066-.076-.1-.013-.075.05-.024.089-.353,2.15-.229,2.263.012,2.289.265,2.263.963,5.4,1.2,5.361.163,2.643-.1,2.655-.52,3.047-.845,2.984-1.153,2.858-1.289,2.2-1.68,1.909-2.011,1.555-2.262,1.163h-4.794l-2.7.708,5.675-.708-2.262-1.163-2.011-1.555-1.68-1.909-1.277-2.2-1.165-2.858-.846-2.984-.519-3.047-.1-2.655.165-2.643,1.2-5.361.962-5.4.266-2.263.011-2.289-.229-2.263-.339-2.15-.038-.089-.075-.05-.1.013-.052.076-.352,2.1-.19,1.113-.505,3.009-.708,2.971-.6,1.618-1.517,4.236-1.251,4.324-.178,1.719-.011-.379-.24.442-.442.2-.483-.114-1.264-.759-1.341-.645-2.742-1.189-2.9-.746-.468-.291-.225-.48-.015.1v-.114l.015.013.1-1.239.43-2.238.151-1.783-.05-1.783-.039-1.732.2-1.732.417-1.694.633-1.011.454-.506.4-.518.038-.1-.024-.114-.1-.063-.152-.013-.14.076-.518.278-.834.417-.318.126-.353-.076-.24-.253-.176-1.808.074-1.808.317-1.783.6-2.971.4-3-.064-.152-.139-.1-.164.013-.139.1-.039.164-.4,1.366-.226.847-.367,1.871-.606,1.808-.686,1.833-.4,1.922-.1,1.96.19,3.212-.165,3.2-.431,2.756-.719,2.706-.456.721-.67.531-.809.278h-.847l-2.669-.607-2.539-.986-.582-.4-.406-.569-.187-.683.075-1.391.226-1.378.2-1.353.088-1.353.062-3.578-.049-1.429.126-1.416.012-.051.467-.733.064-.19-.064-.19-.164-.126h-.052v-.013l.291-1.517.09-1.555-.115-1.9-.315-1.884-.19-1.5-.038-1.517-.075-.228-.19-.1-.227.05-.114.2-.3,2.364-.177,3.1-.18,1.833-.415,1.808-.557,2.213v.038l-1.39.8-1.8,1.467-1.542,1.732L2156.388-347l-1.1,2.213-.406,1.568.1,1.618.583,1.5,1.025,1.265,1.35.885,4.176,1.492,4.247,1.188,4.338.885,3.577.923,3.439,1.353,3.236,1.77,1.619,1.2,1.455,1.4,1.251,1.58,1.164,1.682.936,1.808.7,1.922,1.125,2.491,1.492,2.276,1.834,2.023,2.124,1.707,2.365,1.365,2.552.973h2.659l2.553-.973,2.365-1.365,2.124-1.707,1.834-2.023,1.491-2.276,1.126-2.491.7-1.922.936-1.808,1.163-1.682,1.266-1.58,1.439-1.4,1.62-1.2,3.249-1.77,3.427-1.353,3.58-.923,4.336-.885,4.247-1.188,4.173-1.492,1.351-.885,1.024-1.265.582-1.5.1-1.618Zm-84.513-2.251-.38,2.756-.543,2.719-.279.556-.506.367-.618.1-.886-.329-.682-.682-.329-.885.064-.948,1.163-2,1.389-1.846,1.86-2.2Zm81.706,5.488-.671.682-.9.329-.62-.1L2241-341l-.278-.556-.545-2.719-.379-2.756-.251-2.39,1.857,2.2,1.393,1.846,1.16,2,.064.948Z"
                        transform="translate(-2174.359 353.009)"
                        fill="#EA9B45"
                      ></path>
                      <path id="Path_338" data-name="Path 338" d="M2171.958-343.276l-.006.059v-.066Z" transform="translate(-2159.505 358.814)" fill="#EA9B45"></path>
                      <path id="Path_339" data-name="Path 339" d="M2217.009-343.283v.066l-.007-.059Z" transform="translate(-2171.706 358.814)" fill="#EA9B45"></path>
                    </g>
                  </svg>
                </div>
              </LightgalleryItem>
            </LightgalleryProvider>
            <div className="second">
              <p className="mb-0 title">
                {trophy.user.first_name + " " + trophy.user.last_name}
              </p>
            </div>
            <span className="third">
              <img src={Timer} className="timer-icon" alt=""></img>{" "}
              <p className="address mb-0">{trophy.harvest_date}</p>
            </span>
          </div>
        ))
      ) : !listLoading ? (
        <NoRecordFound message="No trophy yet" />
      ) : (
        <CustomSpinner />
      )}
      {standTrophies && standTrophies?.length > 0 ? (
        <div className="inner-container">
          <Pagination
            totalRecords={totalRecords}
            uiProps={dashboardPageUIProps}
          />
        </div>
      ) : null}
    </div>
  );
}
